import React from 'react';
import { FiBell } from 'react-icons/fi';
import { useNotifications } from '../../context/NotificationContext';
import './NotificationBell.css';

/** Bell button; dropdown is rendered once in NotificationProvider. */
export default function NotificationBell({ className = '' }) {
  const { unreadCount, onBellClick } = useNotifications();

  return (
    <button
      type="button"
      className={`notify-bell-btn ${className}`.trim()}
      aria-label="Notifications"
      onClick={onBellClick}
    >
      <FiBell size={22} aria-hidden />
      {unreadCount > 0 && (
        <span className="notify-badge">{unreadCount > 99 ? '99+' : unreadCount}</span>
      )}
    </button>
  );
}
